import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=a8a09816&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"
import style0 from "./Resumen.vue?vue&type=style&index=0&id=a8a09816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a09816",
  null
  
)

export default component.exports